import { PAGE_ROUTES } from '@/components/nav/utils/url-builders';
import { useArchivedDealByVehicleListingIdQuery } from '@/hooks/fetch-store-and-stitch/use-archived-deals.ts';
import useGoToDeal from '@/hooks/use-go-to-deal';
import { cn } from '@/lib/utils';
import { VehicleListing } from '@/models/registry';
import { dealStore, vehicleListingStore } from '@/models/stores';
import { useNavigate } from '@tanstack/react-router';
import { ChevronRight, ChevronsLeftRight } from 'lucide-react';
import { useEffect } from 'react';
import { DealStatusBadge } from '../deal/status/deal-status-badge';

const NonMobileHeader = ({ listing }: { listing: VehicleListing }) => {
  const navigate = useNavigate();
  const { goToDeal } = useGoToDeal();

  const archivedDealQuery = useArchivedDealByVehicleListingIdQuery({
    vehicleListingId: listing.id,
    enabled: !listing.deal,
  });

  useEffect(() => {
    if (archivedDealQuery.data) {
      const vehicleListing = vehicleListingStore.getById(listing.id);
      if (!vehicleListing) return;
      dealStore.upsertArchivedDeal(archivedDealQuery.data);
      vehicleListingStore.addToIndexedForeignKeys(
        archivedDealQuery.data.id,
        vehicleListing,
      );
    }
  }, [archivedDealQuery.data, listing.id]);

  return (
    <div className="flex w-full h-10 shrink-0 items-center justify-between px-8 py-2 dark:bg-dark">
      <div className="flex flex-row items-center gap-3">
        <div className="flex flex-row items-center gap-2">
          <div
            className="cursor-pointer text-gray-600 dark:text-white"
            onClick={() => {
              navigate({ to: `/${PAGE_ROUTES.CARS}` });
            }}
          >
            Cars
          </div>
          <ChevronRight className={cn('h-3.5 w-3.5', {})} />
          <div className="text-gray-600 dark:text-white">{listing.id}</div>
          <ChevronsLeftRight className={cn('h-3.5 w-3.5', {})} />
          <div className="text-gray-600 dark:text-white">
            {listing.vehicle?.vin}
          </div>
        </div>
      </div>
      <div className="flex flex-row gap-2">
        {listing.deal && (
          <a onClick={() => goToDeal({ dealShortId: listing.deal!.short_id })}>
            <DealStatusBadge
              value={listing.deal.status}
              additionalCopy={`${listing.deal.short_id} - ${listing.deal.primary_customer?.full_name}`}
              className="px-2"
            />
          </a>
        )}
      </div>
    </div>
  );
};

export default NonMobileHeader;
